enum Menu{
	Welcome="主页",
	 UserManager="教务管理",
	 CourseManager="课程管理",// Welcome = 0,     菜单显示   键为url路径  值为菜单
	ManageSalaries="导师信息",
	AddClass="补填课节信息",
	//CtrlCVtoexcel="支付宝批量付款",
	Recovery="删除的课节"

}
export enum MenuIcon{      // 菜单对应的 icon 
	Welcome="el-icon-menu",
   UserManager="el-icon-user",
   CourseManager="el-icon-date",
	ManageSalaries="el-icon-document",
	AddClass="el-icon-setting",
	//CtrlCVtoexcel="el-icon-s-order",
	Recovery="el-icon-delete-solid",
	
}
export function inEnum(what: string, enu: any): string{
    for (const item in enu){
        if (enu[item]==what){
            return item;
        }
    }
    return '';
}
export function numberEnum(what: string, enu: any): number{
	let num = 0;
    for (const item in enu){
        if (item == what){
            return num;
		}
		num++;
    }
    return -1;
}
export default Menu;